export default __webpack_public_path__ + "assets/js/pdf.worker.min-fb69a6fc2c6b7afca3259df68302e382.js";